/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-default[_ngcontent-%COMP%]:hover {\n  color: white;\n  background-color: var(--cust-blue); }\n\n@media (max-width: 767px) {\n  .text-right[_ngcontent-%COMP%] {\n    text-align: left !important; } }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/register/register.component.scss.shim.ngstyle.js.pre-build-optimizer.js